/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // BASE_URL: 'http://127.0.0.1:1337/',
  // BASE_URL: 'http://192.168.0.100:1337/',
  BASE_URL: 'https://restaurantapi-dev.truphle.com/',
  STRIPE_PK: 'pk_test_51H5ev5AdXVwBVNhVvKehivWcZg77KQQqJWPbfnOEPAYjje6XNDVn17UQzxCI1VURXNcIrE1D14ggNYlefUwio8eh00BpcrLkqo',
  ONESIGNAL_APP_ID: 'c411420c-0d98-4cc6-8bbd-f59c073ee912',
  PUBNUB: {
    PUBLISH_KEY: 'pub-c-b9794df3-829c-405a-9db6-f89008cc7fb2',
    SUBSCRIBE_KEY: 'sub-c-488930fa-3585-11ec-b2c1-a25c7fcd9558'
  }
};
